export default {
  name: 'checkbox',
  label: '复选框组',
  icon: 'el-icon-check',
  dataType: 'Array',
  config: [{
    // 可修改的配置选项
    xtype: 'option-list',
    options: {
      label: '选项列表',
      name: 'options',
      default: [{
        label: '选项1',
        value: '选项1'
      }, {
        label: '选项2',
        value: '选项2'
      }, {
        label: '选项3',
        value: '选项3'
      }]
    }
  }]
};